import React, { useEffect } from "react"

import { useDispatch } from "react-redux"

import { AvailableLookupConsumer } from "@common-shared/config/lookup.config"

import { useCptCodes } from "@front-shared/hooks/cptCodes.hook"
import { useScrollFix } from "@front-shared/hooks/scrollFix.hook"

import { embedCalculatorActionCreators } from "../../actions/embedCalculator.actions"
import { CalculatorDataCollectionComponent } from "./calculatorDataCollection.component"

export const CalculatorComponent: React.FunctionComponent = () => {
    useScrollFix()

    const dispatch = useDispatch()

    const { availableCptCodesStyled } = useCptCodes(
        AvailableLookupConsumer.calculator,
    )

    // Reset embed key just in case in state if we've ended up here...
    useEffect(() => {
        dispatch(embedCalculatorActionCreators.setEmbedKey(undefined))
    }, [])

    return availableCptCodesStyled.length ? (
        <CalculatorDataCollectionComponent cptCodes={availableCptCodesStyled} />
    ) : null
}
